export default [
  {
    description: 'Categoria',
    path: '/ged/gedcategoria',
    name: 'ged-categoria',
    component: () => import('@/views/ged/gedcategoria/Index.vue'),
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Categoria',
    parent: 'ged-categoria',
    path: '/ged/gedcategoria/cadastro/:id?',
    name: 'ged-categoria-create',
    component: () => import('@/views/ged/gedcategoria/InclusaoEdicao.vue'),
    goesToMenu: false,
  },
  {
    description: 'Indexação de Categoria',
    parent: 'ged-categoria',
    path: '/ged/gedcategoria/:id/indexacao',
    name: 'ged-categoria-indexacao',
    component: () => import('@/views/ged/gedcategoria/GridIndexacao.vue'),
    goesToMenu: false,
  },
];
